import { PaginationType } from 'src/app/shared/models/pagination.model';

export namespace Pagination {
  export const DEFAULT_PAGE_INDEX = 0;
  export const DEFAUT_PAGE_SIZE = 8;

  export const defaultPagination: PaginationType = {
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAUT_PAGE_SIZE,
  };

  export const getPaginationQuery = (
    keyword: string = '',
    pagination: PaginationType
  ): string =>
    `?keyword=${keyword}&pageIndex=${pagination.pageIndex}&pageSize=${pagination.pageSize}`;
}

export namespace System {
  export const UserStatusClientEvent = {
    Online: 'Online',
    OnDuty: 'OnDuty',
    OnBreak: 'OnBreak',
    InEmergency: 'InEmergency',
    Offline: 'Offline',
    Idle: 'Idle',
    Available: 'Available',
    Busy: 'Busy',
    DoNotDisturb: 'DoNotDisturb',
  } as const;

  export type UserStatusClientEventType = typeof UserStatusClientEvent[keyof typeof UserStatusClientEvent];

  export enum UserType {
    STAFF = 'staff',
    USER = 'user',
  }

  export const UserStatusOptions = [
    {
      name: 'All',
      value: '',
    },
    {
      name: 'Unassigned',
      value: 'UNASSIGNED',
    },
    {
      name: 'Assigned',
      value: 'ASSIGNED',
    },
  ];

  export enum MemberStatus {
    PENDING = 'Pending',
    APPROVED = 'Approved',
    REJECTED = 'Rejected',
  }

  export enum PhysicalStatus {
    NEW = 'New',
    SOLD = 'Sold',
    STAKING = 'Staking',
  }

  export enum DigitalStatus {
    NEW = 'New',
    LOCKED = 'Locked',
    STAKED = 'Staked',
    AVAILABLE = 'Available',
    SOLD = 'Sold',
  }

  export enum TransactionType {
    SELL_DIGITAL_GOLD = 'Sell M-MAS BSE 999.9',
    BUY_DIGITAL_GOLD = 'Buy M-MAS BSE 999.9',
    TRANSFER_DIGITAL_GOLD = 'Transfer M-MAS BSE 999.9', // get buy
    STAKING_DIGITAL_GOLD = 'Staking M-MAS BSE 999.9', // get buy
    RESTOCK_DIGITAL_GOLD = 'Restock M-MAS BSE 999.9', // get sell
  }

  export const DEFAULT_IMAGE_UPLOADER = '/assets/upload-image-plus.png';

  export namespace PermissionModuleV2 {
    export const Supper = {
      SupperPayout: 'SupperPayout',
      SuperUserRole: 'SupperUserRole',
      SuperTenant: 'SupperTenant',
      SuperUpdateTenant: 'SupperUpdateTenant',
    };

    export const Koperasi = {
      KopDashboard: 'KopDashboard',

      KopPayout: 'KopPayout',

      KopInventory: 'KopInventory',
      ImportMMasBSE: 'ImportMMasBSE',

      KopGoldMart: 'KopGoldMart',
      KopSellRequest: 'KopSellRequest',
      ImportPhysical: 'KopImportPhysical',

      KopGoldRate: 'KopGoldRate',

      KopMemberManagement: 'KopMemberManagement',

      KopStaffs: 'KopStaffs',
      // KopCreateStaff: "KopCreateStaff",

      KopGlobalItemSetting: 'KopGlobalItemSetting',

      KopKyc: 'KopKyc',
    };

    export const User = {
      UserDashboard: 'UserDashboard',
      Wallet: 'Wallet',

      UserShopFront: 'UserShopFront',
      UserSellRequest: 'UserSellRequest',
    };

    export const Common = {
      MMASSellRequest: 'MMASSellRequest',

      FullFilment: 'FullFilment',

      TransactionHistory: 'TransactionHistory',

      ListBankAccounts: 'ListBankAccounts',

      ListDependants: 'ListDependants',

      BuyMMasBSE: 'BuyMMasBSE',
      SellMMasBSE: 'SellMMasBSE',
      AssignMMasBSE: 'AssignMMasBSE',
      TransferMMasBSE: 'TransferMMasBSE',
      PurchaseHistory: 'PurchaseHistory',

      SupperRolePermission: 'SupperRolePermission',
      SupperMemberUpload: 'SupperMemberUpload',
      SupperTenants: 'SupperTenants',
      SupperUsers: 'SupperUsers',
      KopUsers: 'KopUsers',
      SupperUserRoles: 'SupperUserRoles',
    };
  }

  export namespace PermissionModule {
    export const KopDashboard = 'KopDashboard';
    export const SupperPayout = 'SupperPayout';
    export const KopPayout = 'KopPayout';
    export const GoldMart = 'GoldMartView';
    export const KopInventory = 'KopInventory';
    export const KopPhysicalGoldSellRequest = 'KopPhysicalGoldSellRequest';
    export const KopFullFilment = 'KopFullFilment';
    export const UserPhysicalGoldMart = 'UserPhysicalGoldMart';
    export const PhysicalGoldSellRequest = 'PhysicalGoldSellRequest';
    export const UserStaking = 'UserStaking';
    export const Wallet = 'DigitalGoldMart'; //Wallet
    export const DigitalGoldSellRequest = 'DigitalGoldSellRequest';
    export const GlobalItemSetting = 'GlobalItemSetting';
    export const ViewStaff = 'ViewStaff';
    export const TransactionHistory = 'TransactionHistory';
    export const MemberManagement = 'ViewMemberManagement';
    export const GoldRate = 'ViewGoldRate';
    export const UpdateGoldRate = 'UpdateGoldRate';
    export const UserRole = 'UserRole';
    export const Users = 'ViewUser';
    export const ViewTenant = 'ViewTenant';
    export const UpdateTenant = 'UpdateTenant';

    export const AccessAll = 'AccessAll';

    export const isHasPermission = (
      permissionArr: string[],
      permissionCheck: any
    ) => {
      return (
        permissionArr.includes(permissionCheck) ||
        permissionArr.includes(AccessAll)
      );
    };
  }

  export enum PaymentStatusType {
    WAITING = 'Waiting For Payment',
    PAID = 'Paid',
    REJECTED = 'Rejected',
  }

  export const PaymentStatus = [
    {
      value: 'Waiting For Payment',
      name: 'waitingForPayment',
    },
    {
      value: 'Paid',
      name: 'paid',
    },
    {
      value: 'Rejected',
      name: 'rejected',
    },
  ];

  export const getPaymentByValue = (value: string) => {
    return PaymentStatus.find((x) => x.value == value);
  };

  export enum dynamicItemType {
    TEXT = 'TEXT',
    PHOTO = 'PHOTO',
    IMAGE = 'IMAGE',
    'PDF' = 'PDF',
  }

  export const TRANSACTION_PRODUCT_CODE = 'Gold 999';
  export const TRANSACTION_PRODUCT_GOLD_CODE = 'Gold 999.9';
  export const TRANSACTION_PRODUCT_GOLD_CODE_SHORT = '999.9';

  export enum FooterMenuRoute {
    HOME = '/home',
    BUY = '/digital-gold/buy/999',
    SELL = '/digital-gold/sell/999',
    WALLET = '/wallet',

    EMAS_INVENTORY = '/staking-list',
    GOLD_MART = '/inventory/kop-inventory',
    RATE_SETTING = '/admin/gold-rate-setting',
  }

  export enum SupplierType {
    GOLD_MART = 'PHYSICAL',
    M_MAS_IVENTORY = 'DIGITAL',
    BOTH = 'BOTH',
  }
}


export namespace LocalNotifcationConstants {
  export enum NotificationId {
    INSIDE_OUTSIDE = 123
  }
}

// ASSIGNMENT CONSTANTS
export interface CellDetailFilter {
  value: string;
  label: string;
  color: string;
  bg: string;
}

export const CELL_DETAIL_FILTERS: CellDetailFilter[] = [
  { value: '', label: 'All', color: '#0284c7', bg: '#e0f2fe' },
  { value: 'active', label: 'Active', color: '#16a34a', bg: '#dcfce7' },
  { value: 'absent', label: 'Absent', color: '#dc2626', bg: '#fee2e2' },
  { value: 'overtime', label: 'OT', color: '#ea580c', bg: '#fff7ed' },
  { value: 'adhoc', label: 'Ad-hoc', color: '#7c3aed', bg: '#ede9fe' },
];

export interface AbsenceType {
  value: string;
  label: string;
  desc: string;
  id: number;
  color: string;
  bg: string;
}

export const ABSENCE_TYPES: AbsenceType[] = [
  { value: 'PH',  label: 'PH',  desc: 'Public Holiday',        id: 1, color: '#e11d48', bg: '#fff1f2' },
  { value: 'MC',  label: 'MC',  desc: 'Medical Certificate',   id: 2, color: '#ea580c', bg: '#fff7ed' },
  { value: 'AL',  label: 'AL',  desc: 'Annual Leave',          id: 3, color: '#0284c7', bg: '#f0f9ff' },
  { value: 'HL',  label: 'HL',  desc: 'Hospitalisation Leave', id: 4, color: '#7c3aed', bg: '#f5f3ff' },
  { value: 'EL',  label: 'EL',  desc: 'Emergency Leave',       id: 5, color: '#dc2626', bg: '#fef2f2' },
  { value: 'UPL', label: 'UPL', desc: 'Unpaid Leave',          id: 6, color: '#64748b', bg: '#f8fafc' },
  { value: 'BL',  label: 'BL',  desc: 'Bereavement Leave',     id: 7, color: '#374151', bg: '#f9fafb' },
  { value: 'ML',  label: 'ML',  desc: 'Maternity Leave',       id: 8, color: '#db2777', bg: '#fdf2f8' },
  { value: 'OFF', label: 'OFF', desc: 'Day Off',               id: 9,  color: '#059669', bg: '#ecfdf5' },
  { value: 'SL',  label: 'SL',  desc: 'Sick Leave',           id: 10, color: '#0891b2', bg: '#ecfeff' },
];

export const ACTION_COLOR_MAP: Record<string, string> = {
    INSERT: '#22c55e',
    UPDATE: '#3b82f6',
    DELETE: '#ef4444',
    AssignStaff: '#16a34a',
    UnassignStaff: '#dc2626',
    UpdateAssignment: '#0284c7',
    'Assign Adhoc': '#7c3aed',
    'Assign Overtime': '#ea580c',
    'Assign Overtime Extra': '#ea580c',
    'Update OvertimeRemark': '#ea580c',
    'Bulk Unassign': '#dc2626',
    'Mark Absence': '#dc2626',
    CancelAbsence: '#16a34a',
    'Create Replacement': '#0284c7',
    'Swap Shift': '#0284c7',
    'Lock Assignment': '#d97706',
    UnlockAssignment: '#d97706',
    AddNote: '#64748b',
    UpdateNote: '#64748b',
    'Assign Staff': '#16a34a',
    'Remove Staff': '#dc2626',
    'Swap Staff': '#0284c7',
    'Mark Absent': '#dc2626',
    'Add Overtime': '#ea580c',
  };

  export const THEME_COLORS = {
    primary: '#0284c7',
    cyan: '#22d3ee',
    violet: '#7c3aed',
    orange: '#ea580c',
    red: '#ef4444',
    active: '#16a34a',
    absent: '#dc2626',
    adhoc: '#7c3aed',
    overtime: '#ea580c',
    leader: '#d97706',
    muted: '#64748b',
  };
